"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.masterPageNames = void 0;
exports.masterPageNames = {
  main: "default",
  simple: "simple"
};
